const oneDay = 24 * 60 * 60 * 1000;

function getFormattedDate(timestamp) {
    const date = new Date();
    date.setTime(timestamp);
    let day = date.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    const month = jQuery.fn.pickadate.defaults.monthsFull[date.getMonth()];
    return {
        day,
        month,
    };
}

function setText(timestamp, day, month) {
    const dateString = getFormattedDate(timestamp);
    $(day).text(dateString.day);
    $(month).text(dateString.month);
}

jQuery('.booking').each(function () {
    const today = new Date();
    const timestamp = today.getTime();
    const timeSpan = $(this).data('timeSpan') * oneDay;

    const fromDay = this.querySelector('.booking-date__from-day');
    const fromMonth = this.querySelector('.booking-date__from-month');
    const toDay = this.querySelector('.booking-date__to-day');
    const toMonth = this.querySelector('.booking-date__to-month');

    const to = $(this)
        .find('.booking__to')
        .pickadate({
            min: 2,
            hiddenName: true,
            onSet: function (context) {
                const select = context.select;
                if (select) {
                    setText(context.select, toDay, toMonth);
                }
            },
        });

    const toPicker = to.pickadate('picker');
    const from = $(this)
        .find('.booking__from')
        .pickadate({
            min: 1,
            hiddenName: true,
            onClose: () => {},
            onSet: function (context) {
                const select = context.select;
                if (select) {
                    const min = new Date();
                    min.setTime(select + oneDay);
                    toPicker.set({
                        min: min,
                        select: select + timeSpan,
                    });
                    setText(select, fromDay, fromMonth);
                }
            },
        });
    const fromPicker = from.pickadate('picker');

    // Set default values
    fromPicker.set('select', timestamp + oneDay);
});
